/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import React from "react";
import { connect } from "react-redux";
import Footer from "../../../app/common/Footer/Footer";
class FooterContainer extends React.Component {
  render() {
    return this.props.auth.isLoggedIn &&
      !this.props.auth.reset_password_response ? (
      <Footer />
    ) : (
      ""
    );
  }
}

function mapStateToProps(state, ownProps) {
  return { auth: state.auth };
}
export default connect(mapStateToProps)(FooterContainer);
